import { Text } from '@wegroup/design-system';
import React from 'react';

interface Props {
  price: string;
  interval: string;
  fontSize?: string | number;
  color?: string;
}

const OfferSidebarSingleSelectedOfferPrice: React.FC<
  React.PropsWithChildren<Props>
> = ({ price, interval, fontSize, color = 'black' }) => {
  return (
    <>
      <Text fontSize={fontSize} color={color}>
        {price}
      </Text>
      {interval && (
        <Text whiteSpace="nowrap" color="gray.200">
          / {interval}
        </Text>
      )}
    </>
  );
};

export default OfferSidebarSingleSelectedOfferPrice;
